import React from 'react'

import { Item } from '@factorialco/deprecated-design-system'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

interface AgreementDropdownProps {
  name: string
  selectedValue: string
  options: Item[]
  onSelect: (value: string, label: string) => void
}

export const AgreementDropdown: React.FC<AgreementDropdownProps> = ({
  selectedValue,
  options,
  onSelect,
}) => (
  <DropdownSearchBar
    name={selectedValue}
    placeholder={i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.agreement_level.select'
    )}
    label=""
    onSelect={(value) => onSelect(value['value'].toString(), value['label'])}
    labelNotFound={i18n.t('common.none')}
    data={options}
    searchLabel={i18n.t('common.search')}
    autofocus={false}
    ellipsis={false}
  />
)
